/* eslint-disable */
export default {
  conferenceCall: 'Llamada de conferencia',
  onHold: 'En espera',
  ongoing: 'En curso',
  unknown: 'Desconocido',
  disconnected: 'Desconectado',
  loading: 'Cargando...',
  loadingTimeout: 'Tiempo de carga expirado.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
